
<div class="row mt-3">
  <div class="col-sm-12 mb-3">
    <app-user-search [searchMode]="singleSearchMode"></app-user-search>
  </div>
</div>
